import * as React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import ERoute from '../../../ERoute'
import { Article, Locale } from '../../../../types'
import MobilityHelper from '../../../../helpers/MobilityHelper'
import { articleLink } from '../../../helpers/NavigationHelper'
import Icon from '../../../../components/Icons/Icon'

const Container = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  padding: 12px 20px;
  align-items: center;
  transition: color 250ms, background-color 250ms;
  opacity: 1;
  cursor: pointer;
  text-decoration: none;
  gap: 8px;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`

const Title = styled.div`
  font-size: 14px;
  line-height: 21px;
  font-weight: 300;
`

const IconContainer = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
`

interface IProps {
  article: Article
}

const ArticleItem = (props: IProps) => {
  const { article } = props
  const currentLocale = Locale.EN
  const title = MobilityHelper.getTranslation(currentLocale, article.translations, 'title')

  return (
    <Container to={articleLink(article)}>
      <Title>{title}</Title>
      <IconContainer>
        <Icon icon='messenger-chevron-right' />
      </IconContainer>
    </Container>
  )
}

export default ArticleItem